module.exports = __webpack_public_path__ + "media/kr_web_5w.5bd84a6e.mp4";